import { LoadingIndicator } from "@dealer-center/core-custom-components";
import styled from "styled-components";

export interface AccountLinkButtonTextAccountNameProps {
  accountName?: string;
  isLoadingAccountName?: boolean;
  htmlSafeAccountId: string;
}
const StyledAccountName = styled.span`
  flex-grow: 1;
  font-size: 0.8em;
  margin-left: 4px;
`;
const StyledLoadingIndicator = styled(LoadingIndicator)`
  margin-left: 4px;
`;

export const AccountLinkButtonTextAccountName = ({
  accountName,
  isLoadingAccountName,
  htmlSafeAccountId
}: AccountLinkButtonTextAccountNameProps) => {
  if (isLoadingAccountName)
    return (
      <StyledLoadingIndicator
        actionName={`account-link-loading-${htmlSafeAccountId}`}
        size="small"
      />
    );
  if (accountName)
    return <StyledAccountName>({accountName})</StyledAccountName>;
  return <></>;
};
